import { CampaignType, OpeningMessageMode } from 'generated-graphql/types';
import Yup from 'utils/validation';
import { getCampaignCreationTemplateVariables } from 'pages/CampaignCreation/utils/getCampaignCreationTemplateVariables';
import { ERROR_MESSAGES } from 'core/constants/errorMessages';
import { validateTemplatedInputVariables } from 'core/utils/validators/validateTemplatedInputVariables';
import { SMS_CUSTOM_MESSAGE_MAX_CHARACTERS } from 'pages/CampaignCreation/constants';
import { GetCampaignInitialValidationObject } from 'modules/campaign-creation/utils/getCampaignCreationSetupValidation';

export type GetCampaignCreationSMSValidationProps = {
  campaignType: CampaignType;
  openingMessageMode: OpeningMessageMode | undefined;
  validationObject: GetCampaignInitialValidationObject;
};

export const getCampaignCreationSMSValidation = ({
  campaignType,
  openingMessageMode,
  validationObject
}: GetCampaignCreationSMSValidationProps) => {
  const newValidationObject = Yup.object().shape({
    ...validationObject,
    customTemplatedMessageCharactersCount: Yup.number().max(
      SMS_CUSTOM_MESSAGE_MAX_CHARACTERS,
      `Must be less than ${SMS_CUSTOM_MESSAGE_MAX_CHARACTERS} characters`
    ),
    templateId: !openingMessageMode
      ? Yup.string().required('This field is required')
      : Yup.string().nullable(),
    customTemplatedSubjectLine: Yup.string().nullable(),
    customTemplatedMessage: Yup.string().nullable()
  });

  if (
    openingMessageMode === OpeningMessageMode.CustomOrTemplatedOpeningMessage
  ) {
    // TODO: Fix this type
    const templatedVariables = getCampaignCreationTemplateVariables(
      campaignType as any
    );
    newValidationObject.shape({
      customTemplatedMessage: Yup.string()
        .test(
          'conditional-requirement',
          'Enter your opening message',
          function (value) {
            return value ?? this.parent.templateId;
          }
        )
        .test(
          'contains-stop',
          ERROR_MESSAGES.templatedInputMusContainsStop,
          function (value) {
            if (this.parent.templateId) return true;

            return value ? value.includes('STOP') : true;
          }
        )
        .test(
          'variable-validation',
          ERROR_MESSAGES.templatedInputVariableMustBeValid,
          function (value) {
            if (this.parent.templateId) return true;
            if (!value) return true;

            return validateTemplatedInputVariables({
              variables: templatedVariables,
              value
            });
          }
        )
        .required('This field is required'),
      templateId: Yup.string().test(
        'conditional-requirement',
        'This field is required',
        function (value) {
          return value ?? this.parent.customTemplatedMessage;
        }
      )
    });
  } else if (
    openingMessageMode === OpeningMessageMode.TemplatedOpeningMessage
  ) {
    newValidationObject.shape({
      templateId: Yup.string().required('This field is required')
    });
  } else if (openingMessageMode === OpeningMessageMode.CustomOpeningMessage) {
    // TODO: Fix this type
    const customVariables = getCampaignCreationTemplateVariables(
      campaignType as any
    );

    newValidationObject.shape({
      customTemplatedMessage: Yup.string()
        .required('Enter your opening message')
        .test(
          'contains-stop',
          ERROR_MESSAGES.templatedInputMusContainsStop,
          function (value) {
            return value ? value.includes('STOP') : true;
          }
        )
        .test(
          'variable-validation',
          ERROR_MESSAGES.templatedInputVariableMustBeValid,
          function (value) {
            if (!value) return true;
            return validateTemplatedInputVariables({
              variables: customVariables,
              value
            });
          }
        )
    });
  }

  return newValidationObject;
};
